import AppBarh from "../components/AppBarh";
import Footer from "../components/Footer";
import { Box, Typography } from "@mui/material";
import * as React from "react";

const Undercons = () => {

 const wrapper: React.CSSProperties = {
    maxWidth: "900px",
    margin: "40px auto",
    padding: "30px",
    backgroundColor: "#ffffff",
    border: "1px solid #ddd",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    color: "#333",
  };

  const title: React.CSSProperties = {
    fontSize: "22px",
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: "30px",
    color: "#1a202c",
  };

  const heading: React.CSSProperties = {
    fontSize: "16px",
    fontWeight: 600,
    marginTop: "30px",
    marginBottom: "10px",
    color: "#2d3748",
    textAlign: "center",
  };

  const paragraph: React.CSSProperties = {
    fontSize: "14px",
    lineHeight: "1.7",
    marginBottom: "20px",
    textAlign: "justify",
  };

  const list: React.CSSProperties = {
    paddingLeft: "20px",
    fontSize: "14px",
    marginBottom: "20px",
  };

  const listItem: React.CSSProperties = {
    marginBottom: "8px",
  };

  const email: React.CSSProperties = {
    color: "#0073e6",
    textDecoration: "none",
  };

  return (

    <div className="Example">
      <AppBarh/>

        <div style={wrapper}>
           <h1 style={title}>Service will be temporarily unavailable</h1>

           <h3 style={heading}>
            We apologize for the inconvenience. Our service is temporarily unavailable due to ongoing payment gateway integration. Thank you for your patience and understanding.
           </h3>

           <br/>

            <p style={paragraph}>
            * Contact us at <a href={'mailto:alumni@std.uwu.ac.lk'}> alumni@std.uwu.ac.lk</a> for any registration-related queries or concerns.
            </p>

         </div>

      <Footer/>
    </div>

  );
};

export default Undercons;